import album from './album';
import analytic from './analytic';
import artist from './artist';
import playlist from './playlist';
import track from './track';
import claim from './claim';
import search from './search';
import auth from './auth';
import users from './users';
import profiles from './profiles';
import utils from './utils';
import pitches from './pitches';
import campaigns from './campaigns';
import copyrightClaims from './copyright-claims';

export default {
	album,
	analytic,
	artist,
	campaigns,
	copyrightClaims,
	playlist,
	track,
	claim,
	auth,
	search,
	users,
	profiles,
	utils,
	pitches,
};
